<form autofocus [formGroup]="form" (ngSubmit)="save()">
    <div class="modal-header">
        <h4 class="modal-title">{{ title | translate }}</h4>
        <button class="close" type="button" aria-label="Close" (click)="activeModal.close()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <div class="row card-border-top">
            <div class="card-body col">
                <div class="row">
                    <div class="col-md-4">
                        <form-textbox
                            labelText="{{ 'Count of containers' | translate }}"
                            formControlName="containerCount"></form-textbox>
                    </div>
                    <div class="col-md-4">
                        <form-datetime
                            labelText="{{ 'Performed Date' | translate }}"
                            formControlName="performedDate"></form-datetime>
                    </div>
                    @if (isUnnamedContainer && containerItemIds?.length === 1) {
                        <div class="col-md-4">
                            <form-textbox
                                labelText="{{ 'Container Number' | translate }}"
                                formControlName="containerNumber"></form-textbox>
                        </div>
                    }
                </div>
                <div class="row mt-2">
                    <div class="col-md-4">
                        <form-textbox
                            labelText="{{ 'Service Request Number' | translate }}"
                            formControlName="serviceRequestId"></form-textbox>
                    </div>
                    <div class="col-md-4">
                        <form-textbox
                            labelText="{{ 'Manipulation' | translate }}"
                            formControlName="manipulation"></form-textbox>
                    </div>
                    <div class="col-md-4">
                        <form-textbox labelText="{{ 'Name/Number' | translate }}" formControlName="name"></form-textbox>
                    </div>
                </div>
                <hr />
                @if (containerItemIds?.length === 1) {
                    <div class="row">
                        <div class="col">
                            <strong>{{ 'Seals' | translate }}</strong>
                        </div>
                    </div>
                }
                @if (containerItemIds?.length === 1) {
                    <div class="row">
                        <div class="col-lg-12 col-md-12 col-sm-12" formArrayName="seals">
                            @for (arrayItem of sealArrayRef.controls; track arrayItem; let i = $index) {
                                <div
                                    [className]="
                                        sealArrayRef.controls[i].controls[5].getRawValue() === true
                                            ? 'row bg-new-seal'
                                            : 'row'
                                    ">
                                    <div class="col-sm-12 col-md-12 col-lg-3">
                                        <form-textbox
                                            labelText="{{ 'Seal Nbr' | translate }}"
                                            [formControl]="sealArrayRef.controls[i].controls[0]"></form-textbox>
                                    </div>
                                    <div class="col-sm-12 col-md-12 col-lg-3">
                                        <form-dropdown
                                            labelText="{{ 'Type' | translate }}"
                                            codeListName="SealType"
                                            [formControl]="sealArrayRef.controls[i].controls[1]"></form-dropdown>
                                    </div>
                                    <div class="col-sm-12 col-md-12 col-lg-4">
                                        <form-textbox
                                            labelText="{{ 'Remark' | translate }}"
                                            [formControl]="sealArrayRef.controls[i].controls[2]"></form-textbox>
                                    </div>
                                    <div class="col-sm-12 col-md-12 col-lg-2">
                                        <button
                                            class="btn btn-sm btn-danger"
                                            type="button"
                                            kendoTooltip
                                            title="{{ 'Cancel' | translate }}"
                                            (click)="cancelSeal(i)">
                                            <fa-icon [icon]="['fas', 'ban']"></fa-icon>
                                        </button>
                                    </div>
                                </div>
                            }
                            <div class="row mt-1">
                                <div class="col-sm-12 col-md-12 col-lg-12 d-flex align-items-end">
                                    <button
                                        class="btn btn-sm btn-primary btn-sm mr-1"
                                        type="button"
                                        (click)="addSeal()">
                                        <fa-icon class="mr-1" [icon]="['fas', 'plus']"></fa-icon>
                                        {{ 'Add' | translate }}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                }
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button class="btn btn-sm btn-primary mr-2" type="submit" translate [disabled]="form.invalid">
            <fa-icon [icon]="['fas', 'check']"></fa-icon>
            &nbsp;&nbsp;{{ 'Confirm' | translate }}
        </button>
        <button class="btn btn-sm btn-secondary" type="button" translate (click)="activeModal.close(null)">
            <fa-icon [icon]="['fas', 'times']"></fa-icon>
            &nbsp;&nbsp;{{ 'Cancel' | translate }}
        </button>
    </div>
</form>
